module.exports = __webpack_public_path__ + "static/media/clone.b89a03ff.svg";